import React from "react";
import { ArrowBackIos, ArrowForwardIos } from "@material-ui/icons";
import { theme } from "./theme";

type FrameAdjusterProps = {
  framePosition: number;
  totalFrames: number;
  clientWidth: number;
  onAdjustFrame: (increment: boolean) => void;
  isTop?: boolean;
};

export const FrameAdjuster: React.FC<FrameAdjusterProps> = ({
  framePosition,
  totalFrames,
  clientWidth,
  onAdjustFrame,
  isTop = false,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        top: isTop ? "-16px" : "35px",
        left: `calc(${(framePosition * clientWidth) / totalFrames}px - 5px)`,
        transform: "translateX(-11px)",
        zIndex: theme.zIndex.button,
        display: "flex",
        flexDirection: "row",
        gap: theme.spacing.small,
      }}
    >
      <div
        style={{
          width: theme.sizes.buttonSize,
          height: theme.sizes.buttonSize,
          borderRadius: theme.borderRadius.small,
          backgroundColor: "rgb(25, 118, 210)",
          // border: `1px solid ${theme.colors.border}`,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: theme.zIndex.button,
        }}
        onClick={(e) => {
          e.stopPropagation()
          onAdjustFrame(false)
        }}
      >
        <ArrowBackIos
          style={{
            fontSize: "12px",
            transform: "translateX(2px)",
            color: "white"
          }}
        />
      </div>
      <div
        style={{
          width: theme.sizes.buttonSize,
          height: theme.sizes.buttonSize,
          borderRadius: theme.borderRadius.small,
          backgroundColor: "rgb(25, 118, 210)",
          // border: `1px solid ${theme.colors.border}`,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={(e) => {
          e.stopPropagation()
          onAdjustFrame(true)
        }}
      >
        <ArrowForwardIos
          style={{
            fontSize: "12px",
            transform: "translateX(1px)",
            color: "white"
          }}
        />
      </div>
    </div>
  );
};
